module.exports = __webpack_public_path__ + "img/57.334d8708.jpg";